import { alpha } from '@mui/material/styles';

import variables from '../../../../contexts/ThemeProvider/variables';

export interface IAccentPalette {
  main: string;
  hover: string;
  soft: string;
  softHover: string;
  selected: string;
  selectedHover: string;
  lockHintBg: string;
  divider: string;
}

/** One opacity recipe for every catalog source, so a new accent is a single call. */
export const buildAccentPalette = (main: string, hover: string): IAccentPalette => ({
  main,
  hover,
  soft: alpha(main, 0.08),
  softHover: alpha(main, 0.14),
  selected: alpha(main, 0.16),
  selectedHover: alpha(main, 0.22),
  lockHintBg: alpha(main, 0.1),
  divider: `${alpha(main, 0.1)} 1px 0px 0px 0px inset`,
});

export const IE_ACCENT_PALETTE = buildAccentPalette(variables.defaultAccentColor, variables.ieBrandHover);
